/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Bookbuild_Emptystate_Message3Inputs */

const en_coinvestments_bookbuild_emptystate_message3 = /** @type {(inputs: Coinvestments_Bookbuild_Emptystate_Message3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set total deal size to see allocation coverage.`)
};

/**
* | output |
* | --- |
* | "Set total deal size to see allocation coverage." |
*
* @param {Coinvestments_Bookbuild_Emptystate_Message3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_bookbuild_emptystate_message3 = /** @type {((inputs?: Coinvestments_Bookbuild_Emptystate_Message3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Bookbuild_Emptystate_Message3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_bookbuild_emptystate_message3(inputs)
});
export { coinvestments_bookbuild_emptystate_message3 as "coInvestments_bookBuild_emptyState_message" }